import { render, staticRenderFns } from "./registerHome.vue?vue&type=template&id=d60ef454&scoped=true"
import script from "./registerHome.vue?vue&type=script&lang=js"
export * from "./registerHome.vue?vue&type=script&lang=js"
import style0 from "./registerHome.vue?vue&type=style&index=0&id=d60ef454&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60ef454",
  null
  
)

export default component.exports